import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  tableId: '',
  rowId: '',
  columns: [],
});

const onLoadData = (data) => ({
  tableId: data?.tableId || '',
  rowId: data?.rowId || '',
  columns: data?.columns || [],
});

const { getStore: getUpdateRowV2Store, defaultStore } = createComponentStore({
  type: 'update_row_v2',
  endpoint: 'update_row_v2',
  registryKey: 'update_row_v2',
  initData,
  onLoadData,
});

export { getUpdateRowV2Store, defaultStore };
export default defaultStore;
